export default __webpack_public_path__ + "static/media/P.f5f6c47f.svg";